import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from "@angular/router";
import { ScanQrCodeComponent } from '../../admin-container/scan-qr-code/scan-qr-code.component';
import { NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-security-default',
  templateUrl: './security-default.component.html',
  styleUrls: ['./security-default.component.scss'],
})
export class SecurityDefaultComponent implements OnInit {
  order: any;
  status: any;
  stockEntryList: any;
  constructor(private ngbModal: NgbModal, public activeModal: NgbActiveModal, private alertService: AlertService, private http: HttpClient, private route: ActivatedRoute, private g: Globals, private api: ApiIntegration, public user: User, private router: Router) {
    this.getApi();
  }
  getApi() {
    if (this.user.role == 'SECURITY') {
      this.api.getStockEntryHeaders("", "1", "IN_TRANSIT").subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.stockEntryList = data.ordersData;
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getStockEntryHeaders("", "1", "ARRIVED").subscribe((data: any) => {
        this.g.loaderDisplay = "";
        this.stockEntryList = data.ordersData;
      }, err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
    }
  }
  boxScan(order) {
    const modalRef = this.ngbModal.open(ScanQrCodeComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'model-width' });
    modalRef.componentInstance.labelName = 'Order Number';
    modalRef.result.then((response) => {
      console.log(response);
      this.g.loaderDisplay = "display";
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.get(environment.apiUrl + 'api/getHeadersByOrderNumber?organizationId=1' + '&status=' + (this.user.role === "SECURITY" ? 'IN_TRANSIT' : 'ARRIVED') + '&stockEntryNumber=' + response, { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (this.user.role == "SECURITY") {
          if (data['id']) {
            this.alertService.success('Order Scan', 'Successfully');
            this.router.navigate(['/admin/stockReceiveView/' + data['id']]);
          }
          else {
            this.alertService.error('Error', data['message']);
          }
        } else {
          if (data['id']) {
            this.alertService.success('Order Scan', 'Successfully');
            this.router.navigate(['/admin/stockReceiveBoxesVerify/' + data['id']]);
          }
          else {
            this.alertService.error('Error', data['message']);
          }
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    }, (reason) => {
    });
  }

  ngOnInit() { }

}
